import { render, staticRenderFns } from "./Privileges.vue?vue&type=template&id=5bd52ff2&scoped=true&"
import script from "./Privileges.vue?vue&type=script&lang=js&"
export * from "./Privileges.vue?vue&type=script&lang=js&"
import style0 from "./Privileges.vue?vue&type=style&index=0&id=5bd52ff2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd52ff2",
  null
  
)

export default component.exports